<template>
    <div>
        <div class="demo-upload-list" v-for="(item,index) in ImgList" :key="index">
            <template v-if="item.path != ''">
                <img :src="DomainApi+item.path">
                <div class="demo-upload-list-cover">
                    <Icon type="ios-eye-outline" @click.native="HandleView(item.path)"></Icon>
                    <Icon type="ios-trash-outline" @click.native="HandleRemove(item)" :class="HideIt"></Icon>
                </div>
            </template>
            <template v-else>
                <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
            </template>
        </div>
        <Upload multiple
                v-if="ImgList.length<MaxLength"
                :show-upload-list="false"
                :on-success="HandleSuccess"
                :format="FormatType"
                :max-size="MaxSizeFormat"
                :on-format-error="HandleFormatError"
                :on-exceeded-size="HandleMaxSize"
                :on-progress="HandleProgress"
                :on-error="HandleError"
                type="drag"
                :action="PortURL"
                :headers="{'Authorization': Authorization,'S_Type': 'PC','S_OpenID': ''}"
                style="display: inline-block;width:100px;"
                :class="HideIt">
            <div style="width: 100px;height:100px;line-height: 100px;" :class="HideIt">
                <Icon type="ios-camera" size="20"></Icon>
            </div>
        </Upload>
        <Modal title="预览" v-model="Visible" footer-hide width="100%" height="100%">
            <img :src="ImgURL"  v-if="Visible" style="width:100%;">
        </Modal>
    </div>
</template>

<script>
    import { domain } from '@/api/apiConfig.js'
    export default {
        name: "UploadImg",
        props:["MaxSize","MaxLength","FormatType","Prop","Value","ChangedList","Type"],
        data(){
            return {
                PortURL:domain.InApi+'api/wangting/upload/upload',//this.axios.defaults.InApi+'api/wangting/upload/upload'，http://192.168.150.191
                ImgURL: '',
                Visible: false,
                ImgList:[],
                CurrentList:[],
                DomainApi:domain.InApi,
                // FormatType:['jpg','jpeg','png'],
                // MaxSize:10,
                // MaxLength:5,
                HideIt:""
            }
        },
        watch: {
            "ChangedList":{
                handler (newVal) {
                    let that = this;
                    if(newVal&&newVal.length>0){
                        that.ImgList = newVal;
                    }
                },
                deep:true,
                immediate: true
            },
        },
        computed:{
            MaxSizeFormat(){
                return this.MaxSize*1024;
            },
            Authorization(){
                return localStorage.getItem("token");
            }
        },
        mounted(){

        },
        methods:{
            HandleView (name) {
                this.ImgURL = this.DomainApi+name;
                this.Visible = true;
            },
            HandleRemove (file) {
                this.ImgList.splice(this.ImgList.indexOf(file), 1);
                // delete this.ImgList["prop"];
                this.$emit("fatherImage",this.ImgList);//父级照片列表变更
            },
            HandleProgress(){
                this.$emit("loadingSpin",true);//开启Spin
            },
            HandleSuccess (res, file) {
                this.$emit("loadingSpin",false);
                let _resData=JSON.parse(res);
                let _responseFile;
                if(_resData.Success){
                    _responseFile=_resData.Data;
                    _responseFile["fileId"]=this.Prop;
                    _responseFile["fileName"]=this.Value;
                }else{
                    this.$Notice.error({title: '上传失败'});
                }
                this.ImgList.push(_responseFile);
                this.ImgList["prop"]=this.Prop;
                let _url =_responseFile.path;
                file.url =domain + _url;
                file.name =this.Value;
                // console.log(this.ImgList)
                this.$emit("fatherImage",this.ImgList);//父级照片列表变更
            },
            HandleFormatError (file) {
                this.$Notice.warning({
                    title: '文件类型限制',
                    desc: '文件' + file.name + '类型错误，请选择'+this.FormatType+'格式'
                });
            },
            HandleMaxSize (file) {
                this.$Notice.warning({
                    title: '文件大小限制',
                    desc: '文件' + file.name + '大小已超过'+this.MaxSize+'M'
                });
            },
            HandleError(){
                this.$store.commit("CanShowModal",true);
                this.$store.commit("ChangeUserName","");
                this.$store.commit("ChangeBaseLayoutActive","PersonalBusinessList");
                this.$router.push("PersonalBusinessList");
                localStorage.removeItem('token');
                localStorage.removeItem('S_UserFlag');
                localStorage.removeItem('S_UserPhone');
                localStorage.removeItem("CurrentActive");
                localStorage.removeItem("BaseData");
                localStorage.removeItem("ZWWToken");
            },
            Reset(){
                this.ImgURL="";
                this.ImgList=[];
            },
        }
    }
</script>

<style scoped>
    /*上传图片*/
    .demo-upload-list{
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin-right: 4px;
    }
    .demo-upload-list img{
        width: 100%;
        height: 100%;
    }
    .demo-upload-list-cover{
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.6);
    }
    .demo-upload-list:hover .demo-upload-list-cover{
        display: block;
    }
    .demo-upload-list-cover i{
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }

    .HideItClass{display: none!important;}
</style>